import React, { useState } from 'react';
import { Container, Row, Col, Button, Card, Badge, Nav, Tab } from 'react-bootstrap';
import { 
   FaBook,  FaAtom, FaFlask, 
  FaRegLightbulb, FaRegFileAlt, FaCalendarAlt, FaUniversity,
  FaMedal, FaChalkboardTeacher, FaUserGraduate, FaLaptop, 
  FaChartLine, FaBookReader, FaAngleRight, FaAngleLeft,
  FaHeartbeat,  FaDna, FaMicroscope, FaStethoscope, 
} from 'react-icons/fa';

const NEETPreparationPage = () => {
  // State for book carousel
  const [currentBookIndex, setCurrentBookIndex] = useState(0);

  // Reference books data
  const referenceBooks = [
    {
      id: 1,
      title: "NCERT Biology Class 11 & 12",
      subject: "Biology",
      author: "NCERT",
      description: "Fundamental concepts with detailed explanations and comprehensive coverage of NEET Biology syllabus.",
      icon: <FaDna />
    },
    {
      id: 2,
      title: "Objective Biology by Dinesh",
      subject: "Biology",
      author: "Dinesh Publications",
      description: "Excellent source for MCQs with chapter-wise coverage and previous year questions.",
      icon: <FaDna />
    },
    {
      id: 3,
      title: "NCERT Chemistry Class 11 & 12",
      subject: "Chemistry",
      author: "NCERT",
      description: "Clear concepts and foundation for NEET Chemistry with well-explained examples.",
      icon: <FaFlask />
    },
    {
      id: 4,
      title: "Physical Chemistry by O.P. Tandon",
      subject: "Chemistry",
      author: "O.P. Tandon",
      description: "Detailed coverage of physical chemistry with focus on numerical problems for NEET.",
      icon: <FaFlask />
    },
    {
      id: 5,
      title: "NCERT Physics Class 11 & 12",
      subject: "Physics",
      author: "NCERT",
      description: "Essential foundation for NEET Physics with clear explanations of concepts.",
      icon: <FaAtom />
    },
    {
      id: 6,
      title: "Concepts of Physics by H.C. Verma",
      subject: "Physics",
      author: "H.C. Verma",
      description: "Comprehensive coverage of physics concepts with numerous solved examples.",
      icon: <FaAtom />
    }
  ];

  // Previous year papers
  const previousYearPapers = [
    {
      year: 2024,
      paperLink: "#",
      solutionLink: "#"
    },
    {
      year: 2023,
      paperLink: "#",
      solutionLink: "#"
    },
    {
      year: 2022,
      paperLink: "#",
      solutionLink: "#"
    },
    {
      year: 2021,
      paperLink: "#",
      solutionLink: "#"
    },
    {
      year: 2020,
      paperLink: "#",
      solutionLink: "#"
    }
  ];

  // Handle book carousel navigation
  const handlePrevBook = () => {
    setCurrentBookIndex((prevIndex) => 
      prevIndex === 0 ? referenceBooks.length - 3 : prevIndex - 1
    );
  };

  const handleNextBook = () => {
    setCurrentBookIndex((prevIndex) => 
      prevIndex === referenceBooks.length - 3 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="neet-page">
      {/* Hero Section */}
      <section className="hero-section py-5" style={{
        background: 'linear-gradient(135deg, rgb(10, 120, 80), rgb(30, 150, 100), rgb(50, 180, 130))',
        color: 'white',
        borderRadius: '0 0 20px 20px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
      }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h1 className="display-4 fw-bold mb-3">Master NEET</h1>
              <h3 className="mb-4">Comprehensive Preparation for NEET UG & PG</h3>
              <p className="lead mb-4">
                Expert-designed study materials, practice tests, and personalized guidance to help you secure admission to top medical colleges across India.
              </p>
              <div className="d-flex gap-3">
                <Button variant="light" size="lg" className="fw-bold">Enroll Now</Button>
                <Button variant="outline-light" size="lg">Download Study Plan</Button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="position-relative" style={{ height: '400px' }}>
                <div className="position-absolute" style={{
                  width: '100%',
                  height: '100%',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '20px',
                  overflow: 'hidden'
                }}>
                  <div className="stack-animation" style={{
                    position: 'absolute',
                    top: '30%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '120px',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}>
                    <FaStethoscope />
                  </div>
                  <div className="position-absolute" style={{
                    bottom: '20px',
                    left: '0',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    <div className="d-flex justify-content-center gap-4">
                      <FaDna size={50} />
                      <FaHeartbeat size={50} />
                      <FaFlask size={50} /> 
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Programs Overview Section */}
      <section className="programs-overview py-5 mt-5">
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Our NEET Programs</h2>
            <p className="lead">Choose the right preparation path for your medical dreams</p>
          </div>
          <Row>
            <Col md={6} className="mb-4">
              <Card className="h-100 program-card shadow-lg" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                  padding: '2rem',
                  color: 'white'
                }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="fw-bold m-0">NEET UG Preparation</h3>
                    <FaCalendarAlt size={30} />
                  </div>
                  <Badge bg="light" text="dark" className="px-3 py-2">MBBS & BDS Admission</Badge>
                </div>
                <Card.Body>
                  <ul className="program-features">
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaBook size={20} />
                      </span>
                      <span>Comprehensive coverage of NEET UG syllabus</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaRegFileAlt size={20} />
                      </span>
                      <span>15+ full-length mock tests with detailed analysis</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaRegLightbulb size={20} />
                      </span>
                      <span>Subject-wise practice questions and solutions</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaChalkboardTeacher size={20} />
                      </span>
                      <span>Live doubt clearing sessions with medical experts</span>
                    </li>
                  </ul>
                  <div className="text-center mt-4">
                    <h4 className="fw-bold">₹16,999</h4>
                    <Button variant="success" className="w-100 mt-3" style={{
                      background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                      border: 'none'
                    }}>Enroll Now</Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card className="h-100 program-card shadow-lg" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #085E40, #0A7850)',
                  padding: '2rem',
                  color: 'white'
                }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="fw-bold m-0">NEET PG Preparation</h3>
                    <FaCalendarAlt size={30} />
                  </div>
                  <Badge bg="light" text="dark" className="px-3 py-2">MD/MS & DNB Specializations</Badge>
                </div>
                <Card.Body>
                  <ul className="program-features">
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaLaptop size={20} />
                      </span>
                      <span>Advanced clinical case discussions & pattern-based MCQs</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaMedal size={20} />
                      </span>
                      <span>Subject-wise high-yield content & grand tests</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaChartLine size={20} />
                      </span>
                      <span>Personal performance tracking & improvement strategy</span>
                    </li>
                    <li className="mb-3 d-flex align-items-center">
                      <span className="feature-icon me-3 text-success">
                        <FaUserGraduate size={20} />
                      </span>
                      <span>Mentoring by top specialists & recent NEET PG toppers</span>
                    </li>
                  </ul>
                  <div className="text-center mt-4">
                    <h4 className="fw-bold">₹29,999</h4>
                    <Button variant="success" className="w-100 mt-3" style={{
                      background: 'linear-gradient(135deg, #085E40, #0A7850)',
                      border: 'none'
                    }}>Enroll Now</Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* NEET Syllabus Section with Tabs */}
      <section className="syllabus-section py-5 mt-5" style={{
        background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
        borderRadius: '20px',
        margin: '0 20px'
      }}>
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">NEET UG & PG Syllabus</h2>
            <p className="lead">Complete syllabus breakdown for effective preparation</p>
          </div>
          
          <Tab.Container defaultActiveKey="biology">
            <Nav variant="pills" className="justify-content-center mb-4">
              <Nav.Item>
                <Nav.Link eventKey="biology" className="px-4 fw-bold" style={{
                  borderRadius: '30px',
                  margin: '0 10px'
                }}>Biology</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="physics" className="px-4 fw-bold" style={{
                  borderRadius: '30px',
                  margin: '0 10px'
                }}>Physics</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="chemistry" className="px-4 fw-bold" style={{
                  borderRadius: '30px',
                  margin: '0 10px'
                }}>Chemistry</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="neetpg" className="px-4 fw-bold" style={{
                  borderRadius: '30px',
                  margin: '0 10px'
                }}>NEET PG</Nav.Link>
              </Nav.Item>
            </Nav>
            
            <Tab.Content>
              <Tab.Pane eventKey="biology">
                <Card className="border-0 shadow-lg">
                  <Card.Header className="py-3" style={{
                    background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                    color: 'white',
                    borderBottom: 'none'
                  }}>
                    <h4 className="m-0 fw-bold">Biology Syllabus (NEET UG)</h4>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <h5 className="fw-bold">Botany</h5>
                        <ul>
                          <li>Cell Biology & Plant Anatomy</li>
                          <li>Morphology of Flowering Plants</li>
                          <li>Plant Physiology</li>
                          <li>Cell Cycle & Cell Division</li>
                          <li>Plant Reproduction</li>
                          <li>Genetics & Evolution</li>
                          <li>Biology & Human Welfare</li>
                          <li>Biotechnology & Its Applications</li>
                          <li>Ecology & Environment</li>
                        </ul>
                      </Col>
                      
                      <Col md={6}>
                        <h5 className="fw-bold">Zoology</h5>
                        <ul>
                          <li>Human Physiology</li>
                          <li>Structural Organization in Animals</li>
                          <li>Animal Kingdom & Diversity</li>
                          <li>Biomolecules</li>
                          <li>Reproduction & Sexual Health</li>
                          <li>Genetics & Evolution</li>
                          <li>Human Health & Disease</li>
                          <li>Animal Husbandry</li>
                          <li>Biodiversity & Conservation</li>
                        </ul>
                      </Col>
                    </Row>
                    
                    <div className="mt-4 p-3" style={{ background: '#e6f7f0', borderRadius: '10px' }}>
                      <h5 className="fw-bold">Important Biology Topics</h5>
                      <p>Topics with higher weightage in recent NEET UG exams:</p>
                      <ul>
                        <li>Human Physiology (Digestive, Respiratory, Circulatory Systems)</li>
                        <li>Genetics & Molecular Basis of Inheritance</li>
                        <li>Cell Biology & Division</li>
                        <li>Plant Physiology (Photosynthesis, Respiration, Growth)</li>
                        <li>Ecology & Environmental Biology</li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Tab.Pane>
              
              <Tab.Pane eventKey="physics">
                <Card className="border-0 shadow-lg">
                  <Card.Header className="py-3" style={{
                    background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                    color: 'white',
                    borderBottom: 'none'
                  }}>
                    <h4 className="m-0 fw-bold">Physics Syllabus (NEET UG)</h4>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <h5 className="fw-bold">Class 11 Physics</h5>
                        <ul>
                          <li>Physical World & Measurement</li>
                          <li>Kinematics & Laws of Motion</li>
                          <li>Work, Energy & Power</li>
                          <li>Motion of System of Particles & Rigid Body</li>
                          <li>Gravitation</li>
                          <li>Properties of Bulk Matter</li>
                          <li>Thermodynamics</li>
                          <li>Behaviour of Perfect Gas & Kinetic Theory</li>
                          <li>Oscillations & Waves</li>
                        </ul>
                      </Col>
                      
                      <Col md={6}>
                        <h5 className="fw-bold">Class 12 Physics</h5>
                        <ul>
                          <li>Electrostatics</li>
                          <li>Current Electricity</li>
                          <li>Magnetic Effects of Current & Magnetism</li>
                          <li>Electromagnetic Induction & Alternating Currents</li>
                          <li>Electromagnetic Waves</li>
                          <li>Optics</li>
                          <li>Dual Nature of Matter & Radiation</li>
                          <li>Atoms & Nuclei</li>
                          <li>Electronic Devices</li>
                        </ul>
                      </Col>
                    </Row>
                    
                    <div className="mt-4 p-3" style={{ background: '#e6f7f0', borderRadius: '10px' }}>
                      <h5 className="fw-bold">Important Physics Topics</h5>
                      <p>Topics with higher weightage in recent NEET UG exams:</p>
                      <ul>
                        <li>Mechanics (Particularly Kinematics & Laws of Motion)</li>
                        <li>Electrostatics & Current Electricity</li>
                        <li>Optics (Ray & Wave Optics)</li>
                        <li>Modern Physics (Particularly Nuclear Physics)</li>
                        <li>Thermodynamics & Kinetic Theory</li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Tab.Pane>
              
              <Tab.Pane eventKey="chemistry">
                <Card className="border-0 shadow-lg">
                  <Card.Header className="py-3" style={{
                    background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                    color: 'white',
                    borderBottom: 'none'
                  }}>
                    <h4 className="m-0 fw-bold">Chemistry Syllabus (NEET UG)</h4>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={4}>
                        <h5 className="fw-bold">Physical Chemistry</h5>
                        <ul>
                          <li>Basic Concepts of Chemistry</li>
                          <li>Structure of Atom</li>
                          <li>Chemical Bonding & Molecular Structure</li>
                          <li>States of Matter</li>
                          <li>Thermodynamics</li>
                          <li>Equilibrium</li>
                          <li>Redox Reactions</li>
                          <li>Electrochemistry</li>
                          <li>Chemical Kinetics</li>
                          <li>Surface Chemistry</li>
                        </ul>
                      </Col>
                      
                      <Col md={4}>
                        <h5 className="fw-bold">Organic Chemistry</h5>
                        <ul>
                          <li>Purification & Characterization</li>
                          <li>Hydrocarbons</li>
                          <li>Organic Compounds with Functional Groups</li>
                          <li>Haloalkanes & Haloarenes</li>
                          <li>Alcohols, Phenols & Ethers</li>
                          <li>Aldehydes, Ketones & Carboxylic Acids</li>
                          <li>Organic Compounds with Nitrogen</li>
                          <li>Biomolecules</li>
                          <li>Polymers</li>
                          <li>Chemistry in Everyday Life</li>
                        </ul>
                      </Col>
                      
                      <Col md={4}>
                        <h5 className="fw-bold">Inorganic Chemistry</h5>
                        <ul>
                          <li>Classification of Elements & Periodicity</li>
                          <li>s-Block Elements</li>
                          <li>p-Block Elements</li>
                          <li>d & f Block Elements</li>
                          <li>Coordination Compounds</li>
                          <li>Environmental Chemistry</li>
                          <li>General Principles of Isolation of Elements</li>
                          <li>Hydrogen</li>
                        </ul>
                      </Col>
                    </Row>
                    
                    <div className="mt-4 p-3" style={{ background: '#e6f7f0', borderRadius: '10px' }}>
                      <h5 className="fw-bold">Important Chemistry Topics</h5>
                      <p>Topics with higher weightage in recent NEET UG exams:</p>
                      <ul>
                        <li>Organic Chemistry (Particularly Named Reactions & Mechanisms)</li>
                        <li>Coordination Chemistry & Chemical Bonding</li>
                        <li>Thermodynamics & Equilibrium</li>
                        <li>Periodic Table & s, p, d Block Elements</li>
                        <li>Mole Concept & Stoichiometry</li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Tab.Pane>
              
              <Tab.Pane eventKey="neetpg">
                <Card className="border-0 shadow-lg">
                  <Card.Header className="py-3" style={{
                    background: 'linear-gradient(135deg, #085E40, #0A7850)',
                    color: 'white',
                    borderBottom: 'none'
                  }}>
                    <h4 className="m-0 fw-bold">NEET PG Syllabus</h4>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <h5 className="fw-bold">Pre-Clinical Subjects</h5>
                        <ul>
                          <li>Anatomy</li>
                          <li>Physiology</li>
                          <li>Biochemistry</li>
                          <li>Microbiology</li>
                          <li>Pathology</li>
                          <li>Pharmacology</li>
                          <li>Forensic Medicine</li>
                        </ul>
                        
                        <h5 className="fw-bold mt-4">Para-Clinical Subjects</h5>
                        <ul>
                          <li>Community Medicine</li>
                          <li>ENT</li>
                          <li>Ophthalmology</li>
                          <li>Dermatology & VD</li>
                          <li>Psychiatry</li>
                        </ul>
                      </Col>
                      
                      <Col md={6}>
                        <h5 className="fw-bold">Clinical Subjects</h5>
                        <ul>
                          <li>General Medicine</li>
                          <li>General Surgery</li>
                          <li>Obstetrics & Gynecology</li>
                          <li>Pediatrics</li>
                          <li>Orthopedics</li>
                          <li>Anesthesiology</li>
                          <li>Radiology</li>
                          <li>Respiratory Medicine</li>
                        </ul>
                        
                        <h5 className="fw-bold mt-4">Recent Updates</h5>
                        <ul>
                          <li>CBME (Competency Based Medical Education)</li>
                          <li>AETCOM (Attitude, Ethics & Communication)</li>
                          <li>Recent Advances in Medical Sciences</li>
                          <li>Pandemic Management & Emerging Diseases</li>
                          <li>Healthcare Policies & Administration</li>
                        </ul>
                      </Col>
                    </Row>
                    
                    <div className="mt-4 p-3" style={{ background: '#e6f7f0', borderRadius: '10px' }}>
                      <h5 className="fw-bold">Important NEET PG Topics</h5>
                      <p>High-yield subjects with greater weightage in the exam:</p>
                      <ul>
                        <li>Medicine (Medical Emergencies, Infectious Diseases, Cardiology)</li>
                        <li>Pediatrics (Growth & Development, Immunization, Common Illnesses)</li>
                        <li>Surgery (Trauma, Acute Abdomen, Surgical Emergencies)</li>
                        <li>OB-GYN (Labor Management, High-Risk Pregnancy, Gynecological Disorders)</li>
                        <li>Pharmacology (Drug Interactions, Therapeutic Uses, Adverse Effects)</li>
                        <li>Pathology (Clinical Pathology, Histopathology, Hematology)</li>
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Container>
      </section>

      {/* Previous Year Papers Section */}
      <section className="previous-papers-section py-5 mt-5">
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Previous Year Papers</h2>
            <p className="lead">Practice with authentic NEET UG & PG question papers</p>
          </div>
          
          <Row>
            <Col lg={6} className="mb-4">
              <Card className="border-0 shadow-lg h-100">
                <Card.Header className="py-3" style={{
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                  color: 'white',
                  borderBottom: 'none'
                }}>
                  <h4 className="m-0 fw-bold">NEET UG Papers</h4>
                </Card.Header>
                <Card.Body>
                  <div className="papers-list">
                    {previousYearPapers.map(paper => (
                      <div key={`ug-${paper.year}`} className="paper-item mb-3 p-3" style={{
                        background: '#e6f7f0',
                        borderRadius: '10px'
                      }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="fw-bold mb-0">NEET UG {paper.year}</h5>
                          <div>
                            <Button variant="outline-success" size="sm" className="me-2">
                              <FaRegFileAlt className="me-1" /> Question Paper
                            </Button>
                            <Button variant="outline-success" size="sm">
                              <FaRegLightbulb className="me-1" /> Solutions
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="text-center mt-4">
                    <Button variant="success" style={{
                      background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                      border: 'none'
                    }}>
                      View All NEET UG Papers
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={6} className="mb-4">
              <Card className="border-0 shadow-lg h-100">
                <Card.Header className="py-3" style={{
                  background: 'linear-gradient(135deg, #085E40, #0A7850)',
                  color: 'white',
                  borderBottom: 'none'
                }}>
                  <h4 className="m-0 fw-bold">NEET PG Papers</h4>
                </Card.Header>
                <Card.Body>
                  <div className="papers-list">
                    {previousYearPapers.map(paper => (
                      <div key={`pg-${paper.year}`} className="paper-item mb-3 p-3" style={{
                        background: '#e6f7f0',
                        borderRadius: '10px'
                      }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="fw-bold mb-0">NEET PG {paper.year}</h5>
                          <div>
                            <Button variant="outline-success" size="sm" className="me-2">
                              <FaRegFileAlt className="me-1" /> Question Paper
                            </Button>
                            <Button variant="outline-success" size="sm">
                              <FaRegLightbulb className="me-1" /> Solutions
                            </Button>
                          </div>
                          </div>
                      </div>
                    ))}
                  </div>
                  <div className="text-center mt-4">
                    <Button variant="success" style={{
                      background: 'linear-gradient(135deg, #085E40, #0A7850)',
                      border: 'none'
                    }}>
                      View All NEET PG Papers
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Reference Books Section with Horizontal Scrolling */}
      <section className="reference-books-section py-5 mt-5" style={{
        background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
        borderRadius: '20px',
        margin: '0 20px'
      }}>
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Best Reference Books</h2>
            <p className="lead">Top recommended books for NEET preparation</p>
          </div>
          
          <div className="book-carousel position-relative">
            <Button 
              variant="light" 
              className="carousel-control carousel-control-prev" 
              onClick={handlePrevBook}
              style={{
                position: 'absolute',
                left: -20,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                width: 40,
                height: 40,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }}
            >
              <FaAngleLeft />
            </Button>
            
            <Row className="mx-2">
              {referenceBooks.slice(currentBookIndex, currentBookIndex + 3).map(book => (
                <Col md={4} key={book.id} className="mb-4">
                  <Card className="h-100 book-card shadow-lg" style={{
                    borderRadius: '15px',
                    overflow: 'hidden',
                    border: 'none',
                    transition: 'transform 0.3s ease'
                  }}>
                    <div style={{
                      height: '180px',
                      background: book.subject === 'Biology' 
                        ? 'linear-gradient(135deg, #0A7850, #1E9664)'
                        : book.subject === 'Physics' 
                          ? 'linear-gradient(135deg, #085E40, #0A7850)'
                          : 'linear-gradient(135deg, #108F60, #0A7850)',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '50px'
                    }}>
                      {book.icon}
                    </div>
                    <Card.Body>
                      <h5 className="fw-bold mb-2">{book.title}</h5>
                      <p className="mb-2 text-muted">Author: {book.author}</p>
                      <Badge bg={book.subject === 'Biology' ? 'success' : book.subject === 'Physics' ? 'primary' : 'info'} className="mb-3">
                        {book.subject}
                      </Badge>
                      <p className="mb-0">{book.description}</p>
                    </Card.Body>
                    <Card.Footer className="bg-white border-0">
                      <Button variant="outline-success" className="w-100">Learn More</Button>
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Button 
              variant="light" 
              className="carousel-control carousel-control-next" 
              onClick={handleNextBook}
              style={{
                position: 'absolute',
                right: -20,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                width: 40,
                height: 40,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
              }}
            >
              <FaAngleRight />
            </Button>
          </div>
        </Container>
      </section>

      {/* Study Strategies Section */}
      <section className="study-strategies-section py-5 mt-5">
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Proven NEET Study Strategies</h2>
            <p className="lead">Expert preparation techniques to maximize your score</p>
          </div>
          
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaBookReader  />
                  </div>
                  <h4 className="fw-bold mb-3">NCERT Focus</h4>
                  <p>Master NCERT textbooks completely. 80% of NEET questions are directly or indirectly from NCERT concepts.</p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaRegFileAlt />
                  </div>
                  <h4 className="fw-bold mb-3">Regular MCQ Practice</h4>
                  <p>Practice at least 50 MCQs daily for each subject to build speed and accuracy in answering questions.</p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaChartLine />
                  </div>
                  <h4 className="fw-bold mb-3">Mock Test Analysis</h4>
                  <p>Take regular full-length mock tests and thoroughly analyze your performance to identify weak areas.</p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaRegLightbulb />
                  </div>
                  <h4 className="fw-bold mb-3">Concept Mapping</h4>
                  <p>Create visual concept maps to connect related topics, especially in biology and biochemistry.</p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaMicroscope />
                  </div>
                  <h4 className="fw-bold mb-3">High-Yield Focus</h4>
                  <p>Prioritize high-yield topics and chapters that consistently appear in NEET exams each year.</p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 strategy-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-container mb-4" style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    color: '#0A7850'
                  }}>
                    <FaCalendarAlt />
                  </div>
                  <h4 className="fw-bold mb-3">Strategic Revision</h4>
                  <p>Follow spaced repetition techniques for revision and create short notes for quick reviews.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Success Stories Testimonials */}
      <section className="testimonials-section py-5 mt-5" style={{
        background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
        borderRadius: '20px',
        margin: '0 20px'
      }}>
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Success Stories</h2>
            <p className="lead">See how our students achieved their medical college dreams</p>
          </div>
          
          <Row>
            <Col md={4} className="mb-4">
              <Card className="h-100 testimonial-card shadow-lg" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                border: 'none'
              }}>
                <div style={{
                  height: '120px',
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                }}></div>
                <div className="text-center" style={{ marginTop: '-50px' }}>
                  <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: '#f0f0f0',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '40px',
                    color: '#0A7850',
                    border: '5px solid white'
                  }}>
                    <FaUserGraduate />
                  </div>
                </div>
                <Card.Body className="text-center pt-3">
                  <h5 className="fw-bold">Aditya Sharma</h5>
                  <p className="text-muted mb-1">AIR 45, NEET UG 2024</p>
                  <p className="text-muted mb-3">AIIMS New Delhi</p>
                  <Card.Text>
                    "The comprehensive study material and mock tests were game-changers for my NEET preparation. The faculty guidance helped me tackle difficult concepts with ease."
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white text-center border-0 pb-4">
                  <Badge bg="success" className="px-3 py-2">690/720 Score</Badge>
                </Card.Footer>
              </Card>
            </Col>
            
            <Col md={4} className="mb-4">
              <Card className="h-100 testimonial-card shadow-lg" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                border: 'none'
              }}>
                <div style={{
                  height: '120px',
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                }}></div>
                <div className="text-center" style={{ marginTop: '-50px' }}>
                  <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: '#f0f0f0',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '40px',
                    color: '#0A7850',
                    border: '5px solid white'
                  }}>
                    <FaUserGraduate />
                  </div>
                </div>
                <Card.Body className="text-center pt-3">
                  <h5 className="fw-bold">Priya Patel</h5>
                  <p className="text-muted mb-1">AIR 78, NEET UG 2024</p>
                  <p className="text-muted mb-3">JIPMER Puducherry</p>
                  <Card.Text>
                    "The personalized study plan and regular performance analysis helped me identify my weaknesses and turn them into strengths before the exam."
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white text-center border-0 pb-4">
                  <Badge bg="success" className="px-3 py-2">682/720 Score</Badge>
                </Card.Footer>
              </Card>
            </Col>
            
            <Col md={4} className="mb-4">
              <Card className="h-100 testimonial-card shadow-lg" style={{
                borderRadius: '15px',
                overflow: 'hidden',
                border: 'none'
              }}>
                <div style={{
                  height: '120px',
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                }}></div>
                <div className="text-center" style={{ marginTop: '-50px' }}>
                  <div style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: '#f0f0f0',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '40px',
                    color: '#0A7850',
                    border: '5px solid white'
                  }}>
                    <FaUserGraduate />
                  </div>
                </div>
                <Card.Body className="text-center pt-3">
                  <h5 className="fw-bold">Dr. Rahul Verma</h5>
                  <p className="text-muted mb-1">AIR 12, NEET PG 2024</p>
                  <p className="text-muted mb-3">MD Radiology, AIIMS Delhi</p>
                  <Card.Text>
                    "The subject specialists and clinical case discussions were invaluable for my PG preparation. The high-yield notes saved me countless hours."
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-white text-center border-0 pb-4">
                  <Badge bg="success" className="px-3 py-2">835/900 Score</Badge>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Colleges Section */}
      <section className="colleges-section py-5 mt-5">
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Top Medical Colleges</h2>
            <p className="lead">Aim for admission to India's premier medical institutions</p>
          </div>
          
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 college-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Header className="py-3 text-center" style={{
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                  color: 'white',
                  borderBottom: 'none',
                  borderRadius: '15px 15px 0 0'
                }}>
                  <h5 className="m-0 fw-bold">AIIMS New Delhi</h5>
                </Card.Header>
                <Card.Body className="text-center">
                  <div className="college-icon mb-3" style={{
                    fontSize: '50px',
                    color: '#085E40'
                  }}>
                    <FaUniversity />
                  </div>
                  <p><Badge bg="light" text="dark" className="px-3 py-2 mb-3">NEET UG Cutoff: 710+</Badge></p>
                  <p>All India Institute of Medical Sciences, Delhi is India's premier medical institution known for excellence in medical education and research.</p>
                </Card.Body>
                <Card.Footer className="bg-white border-0 text-center">
                  <Button variant="outline-success">Learn More</Button>
                </Card.Footer>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 college-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Header className="py-3 text-center" style={{
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                  color: 'white',
                  borderBottom: 'none',
                  borderRadius: '15px 15px 0 0'
                }}>
                  <h5 className="m-0 fw-bold">CMC Vellore</h5>
                </Card.Header>
                <Card.Body className="text-center">
                  <div className="college-icon mb-3" style={{
                    fontSize: '50px',
                    color: '#085E40'
                  }}>
                    <FaUniversity />
                  </div>
                  <p><Badge bg="light" text="dark" className="px-3 py-2 mb-3">NEET UG Cutoff: 695+</Badge></p>
                  <p>Christian Medical College, Vellore is renowned for its medical excellence and holistic approach to healthcare education.</p>
                </Card.Body>
                <Card.Footer className="bg-white border-0 text-center">
                  <Button variant="outline-success">Learn More</Button>
                </Card.Footer>
              </Card>
            </Col>
            
            <Col lg={4} md={6} className="mb-4">
              <Card className="h-100 college-card shadow-sm" style={{
                borderRadius: '15px',
                border: 'none',
                transition: 'transform 0.3s ease'
              }}>
                <Card.Header className="py-3 text-center" style={{
                  background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                  color: 'white',
                  borderBottom: 'none',
                  borderRadius: '15px 15px 0 0'
                }}>
                  <h5 className="m-0 fw-bold">JIPMER Puducherry</h5>
                </Card.Header>
                <Card.Body className="text-center">
                  <div className="college-icon mb-3" style={{
                    fontSize: '50px',
                    color: '#085E40'
                  }}>
                    <FaUniversity />
                  </div>
                  <p><Badge bg="light" text="dark" className="px-3 py-2 mb-3">NEET UG Cutoff: 690+</Badge></p>
                  <p>Jawaharlal Institute of Postgraduate Medical Education & Research is among the top medical institutions in India.</p>
                </Card.Body>
                <Card.Footer className="bg-white border-0 text-center">
                  <Button variant="outline-success">Learn More</Button>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
          
          <div className="text-center mt-4">
            <Button variant="success" size="lg" style={{
              background: 'linear-gradient(135deg, #0A7850, #1E9664)',
              border: 'none'
            }}>
              Explore All Medical Colleges
            </Button>
          </div>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="faq-section py-5 mt-5" style={{
        background: 'linear-gradient(135deg, #e6f7f0, #cce6e0)',
        borderRadius: '20px',
        margin: '0 20px 20px'
      }}>
        <Container>
          <div className="section-header text-center mb-5">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
            <p className="lead">Get answers to common questions about NEET preparation</p>
          </div>
          
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card className="border-0 shadow-lg mb-4">
                <Card.Header className="bg-white border-0 py-3">
                  <h5 className="mb-0 fw-bold">What is the eligibility criteria for NEET UG?</h5>
                </Card.Header>
                <Card.Body>
                  <p className="mb-0">Candidates must have completed 10+2 or equivalent with Physics, Chemistry, Biology/Biotechnology, and English as core subjects. The minimum age requirement is 17 years as of December 31st of the admission year, and there is an upper age limit of 25 years (relaxable by 5 years for SC/ST/OBC-NCL/PwD candidates).</p>
                </Card.Body>
              </Card>
              
              <Card className="border-0 shadow-lg mb-4">
                <Card.Header className="bg-white border-0 py-3">
                  <h5 className="mb-0 fw-bold">How many attempts are allowed for NEET UG and PG?</h5>
                </Card.Header>
                <Card.Body>
                  <p className="mb-0">For NEET UG, there is no limit on the number of attempts. For NEET PG, candidates can appear for the exam as many times as they wish, provided they meet the eligibility criteria.</p>
                </Card.Body>
              </Card>
              
              <Card className="border-0 shadow-lg mb-4">
                <Card.Header className="bg-white border-0 py-3">
                  <h5 className="mb-0 fw-bold">What is the exam pattern for NEET UG?</h5>
                </Card.Header>
                <Card.Body>
                  <p>NEET UG is a 3-hour pen-and-paper test with 200 multiple-choice questions (180 to be attempted), divided as follows:</p>
                  <ul>
                    <li>Physics: 45 questions (40 to attempt)</li>
                    <li>Chemistry: 45 questions (40 to attempt)</li>
                    <li>Botany: 45 questions (40 to attempt)</li>
                    <li>Zoology: 45 questions (40 to attempt)</li>
                  </ul>
                  <p className="mb-0">Each correct answer earns 4 marks, while each incorrect answer deducts 1 mark. Unattempted questions receive zero marks.</p>
                </Card.Body>
              </Card>
              
              <Card className="border-0 shadow-lg mb-4">
                <Card.Header className="bg-white border-0 py-3">
                  <h5 className="mb-0 fw-bold">How should I prepare for NEET PG?</h5>
                </Card.Header>
                <Card.Body>
                  <p className="mb-0">For NEET PG, focus on high-yield topics, practice with previous year questions, take regular mock tests, create concise notes for revision, join a structured coaching program, and develop clinical reasoning skills. Also, stay updated with recent advances in medical sciences and guidelines published by major health organizations.</p>
                </Card.Body>
              </Card>
              
              <Card className="border-0 shadow-lg">
                <Card.Header className="bg-white border-0 py-3">
                  <h5 className="mb-0 fw-bold">Is NCERT sufficient for NEET UG preparation?</h5>
                </Card.Header>
                <Card.Body>
                  <p className="mb-0">NCERT textbooks form the foundation of NEET UG preparation and around 70-80% of questions come directly or indirectly from NCERT concepts. However, for advanced concepts and competitive edge, supplementing with other reference books and question banks is recommended, especially for Physics and Chemistry.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          
          <div className="text-center mt-5">
            <h4 className="mb-4">Still have questions?</h4>
            <Button variant="success" size="lg" style={{
              background: 'linear-gradient(135deg, #0A7850, #1E9664)',
              border: 'none'
            }}>
              Contact Our Counselors
            </Button>
          </div>
        </Container>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section py-5" style={{
        background: 'linear-gradient(135deg, #0A7850, #1E9664)',
        borderRadius: '20px',
        margin: '0 20px',
        color: 'white'
      }}>
        <Container className="text-center">
          <h2 className="fw-bold mb-4">Ready to Begin Your Medical Journey?</h2>
          <p className="lead mb-5">Join thousands of successful students who achieved their NEET dreams with our comprehensive preparation programs.</p>
          <Row className="justify-content-center">
            <Col md={4} className="mb-3 mb-md-0">
              <Card className="h-100 shadow-lg" style={{
                borderRadius: '15px',
                border: 'none'
              }}>
                <Card.Body className="d-flex flex-column justify-content-between text-center p-4">
                  <div>
                    <h4 className="fw-bold text-success mb-3">Free Trial</h4>
                    <p>Experience our platform with a 7-day free access pass</p>
                  </div>
                  <Button variant="outline-success" className="mt-3">Start Free Trial</Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-3 mb-md-0">
              <Card className="h-100 shadow-lg" style={{
                borderRadius: '15px',
                border: 'none',
                transform: 'scale(1.05)'
              }}>
                <div className="ribbon position-absolute" style={{
                  top: '10px',
                  right: '-5px',
                  backgroundColor: '#0A7850',
                  color: 'white',
                  padding: '5px 15px',
                  fontWeight: 'bold',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 1
                }}>
                  POPULAR
                </div>
                <Card.Body className="d-flex flex-column justify-content-between text-center p-4">
                  <div>
                    <h4 className="fw-bold text-success mb-3">Schedule Counseling</h4>
                    <p>Get personalized guidance from our expert counselors</p>
                  </div>
                  <Button variant="success" className="mt-3" style={{
                    background: 'linear-gradient(135deg, #0A7850, #1E9664)',
                    border: 'none'
                  }}>
                    Book Free Session
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 shadow-lg" style={{
                borderRadius: '15px',
                border: 'none'
              }}>
                <Card.Body className="d-flex flex-column justify-content-between text-center p-4">
                  <div>
                    <h4 className="fw-bold text-success mb-3">Full Access</h4>
                    <p>Unlock complete study materials, mock tests, and mentorship</p>
                  </div>
                  <Button variant="outline-success" className="mt-3">View Packages</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <p className="mt-5 mb-0">Join 50,000+ successful medical aspirants who achieved their dreams with us!</p>
        </Container>
      </section>
      </div>
  );
}
export default NEETPreparationPage;